import { render, staticRenderFns } from "./menuProfile.vue?vue&type=template&id=eb19c4d6&scoped=true&"
import script from "./menuProfile.vue?vue&type=script&lang=js&"
export * from "./menuProfile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb19c4d6",
  null
  
)

export default component.exports